import { render, staticRenderFns } from "./talent8.vue?vue&type=template&id=1b14171c&scoped=true"
import script from "./talent8.vue?vue&type=script&lang=js"
export * from "./talent8.vue?vue&type=script&lang=js"
import style0 from "./talent8.vue?vue&type=style&index=0&id=1b14171c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b14171c",
  null
  
)

export default component.exports